import { ErrorHandler } from "@/Helpers/ErrorHandler.js"
import { convertObjectKeysToSnakeCase } from "@/Helpers/Utils.js"
import MeterDetailRepository from "@/repositories/MeterDetailRepository.js"

export class MeterDetailService {
  constructor() {
    this.repository = MeterDetailRepository
    this.meter = {
      id: null,
      serialNumber: null,
      deviceId: null,
      registered: null,
      manufacturer: null,
      tariff: null,
      owner: null,
      connectionType: null,
      connectionGroup: null,
      loaded: false,
      meterType: null,
      totalRevenue: null,
      tokens: [],
      lastPaymentDate: null,
    }
  }

  fromJson(data) {
    this.meter = {
      id: data.id,
      serialNumber: data.serial_number,
      deviceId: data.device.id,
      manufacturerMappingStatus: data.device.manufacturer_mapping_status,
      manufacturerMappingCheckedAt: data.device.manufacturer_mapping_checked_at,
      registered: data.created_at,
      manufacturer: data.manufacturer,
      tariff: data.tariff,
      owner: data.device.person,
      loaded: true,
      meterType: data.meter_type,
      connectionType: data.connection_type,
      connectionGroup: data.connection_group,
      tokens: data.tokens,
      totalRevenue: data.tokens.reduce(
        (acc, curr) => acc + curr.transaction.amount,
        0,
      ),
      lastPaymentDate:
        data.tokens.length > 0
          ? data.tokens.sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at),
            )[0].created_at
          : null,
    }
  }

  async getDetail(serialNumber) {
    try {
      const { status, data, error } = await this.repository.detail(serialNumber)
      if (status !== 200) return new ErrorHandler(error, "http", status)

      return this.fromJson(data.data)
    } catch (e) {
      const errorMessage = e.response.data.message
      return new ErrorHandler(errorMessage, "http")
    }
  }

  async updateMeterDetails(meterData) {
    const params = convertObjectKeysToSnakeCase(meterData)
    try {
      const { data, status, error } = await this.repository.update(
        meterData.id,
        params,
      )
      if (status !== 200 && status !== 201)
        return new ErrorHandler(error, "http", status)
      return data.data
    } catch (e) {
      return new ErrorHandler(e.response.data.message, "http")
    }
  }
}
